import { render, staticRenderFns } from "./ExperimentDetails.vue?vue&type=template&id=d7ffc23e&scoped=true&"
import script from "./ExperimentDetails.vue?vue&type=script&lang=js&"
export * from "./ExperimentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentDetails.vue?vue&type=style&index=0&id=d7ffc23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ffc23e",
  null
  
)

export default component.exports